import { render } from "./HepaticsCheckilstMurmansk.vue?vue&type=template&id=a1d5a85c"
import script from "./HepaticsCheckilstMurmansk.vue?vue&type=script&lang=js"
export * from "./HepaticsCheckilstMurmansk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__